import { isNullOrEmpty, isNonEmptyArray } from '@/utils'
import {
  ORDER_STATE_ENUM,
  ORDER_REFUND_STATE_ENUM,
  ORDER_WORK_STATE_SHANG_HU_ENUM,
  YS_REFUND_STATE_ENUM,
  YS_S_AFTER_SALE_STATE_ENUM
} from '@/config'

export default class {
  /**
   * 月嫂服务中
   * 已上户
   * state === 20 && homeApplycationState === 40
   * @param {Number | string} orderState
   * @param {Number | string} homeApplycationState
   */
  static isInService(orderState, homeApplycationState) {
    return (
      orderState == ORDER_STATE_ENUM.TO_BE_USED &&
      +homeApplycationState === ORDER_WORK_STATE_SHANG_HU_ENUM.YI_QUEREN_SHANGHU
    )
  }
  /**
   * 用户已支付
   * 等待月嫂服务
   * 月嫂需要主动操作上户申请
   * state === 20 && homeApplycationState === 0
   * @param {Number | string} orderState
   * @param {Number | string} homeApplycationState
   */
  static is2BeServiced(orderState, homeApplycationState) {
    return (
      orderState == ORDER_STATE_ENUM.TO_BE_USED &&
      +homeApplycationState !==
        ORDER_WORK_STATE_SHANG_HU_ENUM.YI_QUEREN_SHANGHU &&
      +homeApplycationState !==
        ORDER_WORK_STATE_SHANG_HU_ENUM.YI_SHENGQING_SHANG_HU
    )
  }
  /**
   * 月嫂已经申请上户
   * 待用户确认上户
   * state === 20 && homeApplycationState === 30
   * @param {Number | string} orderState
   * @param {Number | string} homeApplycationState
   */
  static isHomeApplied(orderState, homeApplycationState) {
    return (
      orderState == ORDER_STATE_ENUM.TO_BE_USED &&
      +homeApplycationState ===
        ORDER_WORK_STATE_SHANG_HU_ENUM.YI_SHENGQING_SHANG_HU
    )
  }

  /**
   * 月嫂已经申请上户
   * state === 20 && homeApplycationState === 30
   * @param {Number | string} orderState
   * @param {Number | string} homeApplycationState
   */
  static isDOOR2DOOR(homeApplycationState) {
    return (
      +homeApplycationState ===
      ORDER_WORK_STATE_SHANG_HU_ENUM.YI_SHENGQING_SHANG_HU
    )
  }

  /**
   * 待支付
   * state === 10
   * @param {Number| string} state
   */
  static isPendingPayment(state) {
    return state == ORDER_STATE_ENUM.PENDING_PAY
  }
  /**
   * 待评价
   * state === 30
   * @param {Number|string} state
   */
  static isWaiting4Evaluation(state) {
    return state == ORDER_STATE_ENUM.WAITING_4_EVALUATE
  }
  /**
   * 订单已完成
   * state === 40
   * @param {Number|string} state
   */
  static isFinished(state) {
    return state == ORDER_STATE_ENUM.FINISHED
  }
  /**
   * 订单已完成,已评价
   * @param {Number|string} state
   * @param {String} commentID
   */
  static isFinishedAndEvaluated(state, commentID) {
    return state == ORDER_STATE_ENUM.FINISHED && !isNullOrEmpty(commentID)
  }
  /**
   * 判定是否已取消
   * state === 50
   *  @param {String|Number} state
   */
  static isCanceled(state) {
    return state == ORDER_STATE_ENUM.CANCELED
  }
  /**
   * "barcodeList":"[{
   *    "barCode": "CZ8464651358735435", //核销码
   *    "barCodeUseEndTime": 685746846541684435, //有效期,时间戳
   *    "workState":30, //仅限签约月嫂 上户状态 30 已申请上户 40 已确认上户 其他 未申请上户
   *    "applyHouseHoldTime":"2020-05-11",//仅限签约月嫂 申请上户时间
   *    "confirmHouseHoldTime": "2020-05-11",//仅限签约月嫂 确认上户时间
   *    "userName":"张三",//仅限签约月嫂 雇主名称
   *    "userMobile":"13885800335",//仅限签约月嫂 雇主电话
   *    "barcodeIsValid":1  过期标识  1 未过期  0 已过期
   *    "writeoffTime":"2020-05-09 13:45:00" 核销时间
   *    "barcodeState":0   核销状态 0 待核销   1 已正常核销  3 已过期核销
   *  }]",
   */
  static getWorkState(order) {
    const b = this.getBarCodeInfo(order)
    return b.workState || 0
  }
  /**
   * @param {object} order
   * @returns {object} {barCode,barCodeUseEndTime,workState,applyHouseHoldTime,confirmHouseHoldTime,userName,userMobile,barcodeIsValid,writeoffTime,barcodeState}
   */
  static getBarCodeInfo(order) {
    const barcodeList = order.barcodeList
    if (isNonEmptyArray(barcodeList)) {
      return barcodeList[0]
    }
    return {}
  }
  static isNotApplied(refundState) {
    return refundState == ORDER_REFUND_STATE_ENUM.NOT_APPLIED
  }
  static isRefundFailed(refundState) {
    return refundState == ORDER_REFUND_STATE_ENUM.FAILED
  }
  static isApplied(refundState) {
    return refundState == ORDER_REFUND_STATE_ENUM.APPLIED
  }
  static hasAppliedRefund(refundStatus) {
    return refundStatus == YS_REFUND_STATE_ENUM.HAS_APPLIED
  }
  static hasCancelRedund(refundStatus) {
    return refundStatus == YS_REFUND_STATE_ENUM.HAS_CANCEL
  }
  static hasAppliedAfterService(sasState) {
    return sasState == YS_S_AFTER_SALE_STATE_ENUM.HAS_APPLIED
  }
  static hasCancelAfterService(sasState) {
    return sasState == YS_S_AFTER_SALE_STATE_ENUM.HAS_CANCEL
  }
  static isVirtual(workerType) {
    return +workerType === 2
  }
}
